import { GameObject3D } from './../classes/types'
import { Object3D } from 'three'
import { useScenesStore } from '../../../b.providers/ScenesProvider/store'
import getGameElementFromObj from './getGameElementFromObj'

const getGameElementByUUID = (uuid: string) => {
  const gameElementObj = useScenesStore.getState().getGameObject3D(uuid) || new Object3D()
  return getGameElementFromObj(gameElementObj as GameObject3D)
}

export default getGameElementByUUID
